/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-nested-ternary */
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  primaryFont, primaryHeadingColor,
  wMedium, maxWidth, retina, primaryColor, boxShadow, wLight, wMBold, maxMobile,
} from 'Utils/utilsStyle';
import TruncateMarkeup from 'react-truncate-markup';
import HTMLReactParser from 'html-react-parser';
import classNames from 'classnames';
import { Tooltip } from 'antd';
// import Edit from '../assets/svgIcons/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { actions as helperActions } from 'Slice/HelperSlice';
import {
  personCard, selectEditPhoneEmailLoading, selectIsEditingEmail, selectIsEditingPhone,
} from 'Selector/PersonProfileSelector';
import { actions } from 'Slice/PersonProfileSlice';
import { PersonCard } from 'Types/PersonTypes';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import Cookies from 'js-cookie';
import Tick from '../assets/svgIcons/Tick';
import Cross from '../assets/svgIcons/Cross';
import WhiteEditSvg from '../assets/svgIcons/WhitEditSvg';

type Props = {
  title?: string;
  description?: string;
  rows?: number;
  editable?: boolean;
  isPhone?: boolean;
  customClass?: string;
};

const Wrapper = styled.div`
  border-radius: 16px;
  background-color: rgb(255,255,255);
  box-shadow: 0px 0px 24px rgb(0 0 0 / 10%);
  padding: 16px 24px 24px 24px;
  margin-bottom: 16px; 
  body {
    background-color: transparent;
  }
  h3 {
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 20px;
  letter-spacing: -0.42px;
  line-height: 30px;
  color: ${primaryHeadingColor};
  margin-bottom: 0;
  .email-edit-tooltip{
      .ant-tooltip-content{
        width: fit-content;
        .ant-tooltip-inner{
          color: ${primaryHeadingColor};
          font-family: ${primaryFont};
          font-weight: ${wMBold};
          font-size: 14px;
          line-height: 16px;
          padding: 7px 16px;
          border-radius: 5px;
          min-height: unset;
          margin-bottom: -13px;
        }
      }
      &.isEditing{
        svg{
          path {
            fill: ${primaryColor};
          }
        }
      }
    &.edit-text{
      cursor: pointer;
      @media all and (max-width: ${maxWidth}) , ${retina}{
        margin-left: 7px;
      }
      svg {
        &:hover {
          path {
            fill: ${primaryColor};
          }
        }
        @media all and (max-width: ${maxWidth}), ${retina}{
          height: 16px;
          width: 16px;
        }
      }
    }
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px !important;
      line-height: 20px !important;
    }
  }
  .para-text {
    white-space: break-spaces;
    &.more {
      color: ${primaryColor};
      cursor: pointer;
      display: inline-flex;
      margin-left: 2px;
    }
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    letter-spacing: -0.42px;
    line-height: 25px;
    color: #67696A;
    margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 14px !important;
        line-height: 20px !important;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 12px !important;
        line-height: 16px !important;
      }
  }
  div > a {
    color:#1EC252;
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16;
    letter-spacing: -0.42px;
    line-height: 25px;
    &:hover {
      color: #1EC252
    }
  }
  .editable {
  position: relative;
  width: 294px;
  height: 30px;
  &.isDisplay {
    display: block;
  }
  input {
    background-color: #fff;
    border-radius: 8px;
    border: none;
    width: 100%;
    height: 34px;
    outline: none;
    padding: 0 70px 0 15px;
    font-size: 16px;
    box-shadow: ${boxShadow};
    color: #67696A;
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: 34px;
      margin-top: 5px;
    }
    &:focus,
    &:active {
      outline: none;
    }
  }
  .icon-container {
    position: absolute;
    align-items: center;
    display: flex;
    top: -.5rem;
    right: 1rem;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin-top: 3px;
    }
    .tick {
      cursor: pointer;
      top: 22px;
      height: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      margin-top: 8px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        margin-top: 8px;
        margin-left: 10px;
        right: 5px;
        height: 13px;
      }
      svg {
        width: 13px;
        height: 13px;
      }
    }
    .cross {
      cursor: pointer;
      top: 0;
      height: 40px;
      align-items: center;
      justify-content: center;
      display: flex;
      @media all and (max-width: ${maxWidth}), ${retina} {
        top: 4px;
        height: 44px;
      }
      svg {
        margin-top: 10px;
        max-width: 10px;
        height: 10px;
      }
    }
  }
  .separator {
    margin-left: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 9px;
    color: #A0A0A0;
    @media all and (max-width: ${maxWidth}), ${retina} {
      margin-top: 7px;
    }
  }
}

  .tiles-styling{
    font-style: italic;
    font-size: 14px;
    color: #979797;
    font-family: ${primaryFont};
    font-weight: ${wLight};
    @media all and (max-width: ${maxWidth}), ${retina}{
      font-size: 20px;
    }
  }
`;

const HeadingContent = styled.h6`
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 20px;
  letter-spacing: -0.42px;
  line-height: 30px;
  color: ${primaryHeadingColor};
  margin-bottom: 10;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 18px;
    line-height: 26px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 16px;
    line-height: 18px;
  }
`;

const defaultProps = {
  title: '',
  customClass: '',
  description: '',
  rows: 3,
  editable: false,
  isPhone: false,
};
const TypographyBlock: FC<Props> = function TypographyBlock({
  title, description, customClass,
  rows, editable, isPhone,
}) {
  const [visible, setVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedText, setEditedText] = useState(description);
  const dispatch = useDispatch();
  const startTime = getCurrentTime();
  const personProfileCard: PersonCard = useSelector(personCard);
  const editPhoneEmailLoading = useSelector(selectEditPhoneEmailLoading);
  const personId = personProfileCard?.personId;
  const contactId = personProfileCard?.contactId;
  const isEditingPhone = useSelector(selectIsEditingPhone);
  const isEditingEmail = useSelector(selectIsEditingEmail);

  const currentLanguage = Cookies.get('xiqtrans');

  useEffect(() => {
    if (!editPhoneEmailLoading) {
      setIsEditing(false);
    }
  }, [editPhoneEmailLoading]);

  const toggleTruncate = () => {
    setVisible(!visible);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (isPhone) {
      const phoneRegex = /^\+?\d*$/;
      if (phoneRegex.test(value) || value === '') {
        setEditedText(value);
      }
    } else {
      setEditedText(value);
    }
  };

  const handleEdit = () => {
    if (isPhone) {
      const data = {
        personId,
        contactId,
        phone: editedText,
      };
      dispatch(actions.editPhoneEmail(data));
      dispatch(helperActions.callFlurryEvent(
        valueToObject('saved_edit_phone Number', startTime, data),
      ));
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(editedText || '')) {
        const data = {
          personId,
          contactId,
          email: editedText,
        };
        dispatch(actions.editPhoneEmail(data));
        dispatch(helperActions.callFlurryEvent(
          valueToObject('saved_edit_emailAddress', startTime, data),
        ));
      } else {
        dispatch(helperActions.setNotification({
          message: 'Invalid Email',
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    }
  };

  const handleEditClick = () => {
    if (!isEditing || !((isPhone && isEditingPhone) || (!isPhone && isEditingEmail))) {
      if (isPhone && !description) {
        setEditedText('+');
      } else {
        setEditedText(description);
      }
      if (isPhone) {
        dispatch(actions.setIsEditingPhone(true));
        dispatch(actions.setIsEditingEmail(false));
        dispatch(helperActions.callFlurryEvent(
          valueToObject('clicked_edit_phoneNumber', 0, {}),
        ));
      } else {
        dispatch(actions.setIsEditingPhone(false));
        dispatch(actions.setIsEditingEmail(true));
        dispatch(helperActions.callFlurryEvent(
          valueToObject('clicked_edit_emailAddress', 0, {}),
        ));
      }
      setIsEditing(true);
    }
  };

  const handleEditCancel = () => {
    setIsEditing(false);
    if (isPhone) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('cancel_edit_phoneNumber', 0, {}),
      ));
    } else {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('cancel_edit_emailAddress', 0, {}),
      ));
    }
  };

  const disableHandleEdit = () => editPhoneEmailLoading || editedText === description || !editedText?.length || editedText === '+';

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !disableHandleEdit()) {
      handleEdit();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  const readMoreEllipsis = (
    <>
      {title === 'About' ? <br /> : null}
      <span
        tabIndex={0}
        role="button"
        onClick={() => toggleTruncate()}
        onKeyPress={() => toggleTruncate()}
        className="para-text more"
      >
        more...
      </span>
    </>
  );
  return (
    <Wrapper className={`${customClass}`}>
      <div className="item">
        <HeadingContent>
          {title}
          {' '}
          {editable ? (
            <Tooltip
              placement="top"
              getPopupContainer={(e: HTMLElement) => e}
              className="email-edit-tooltip"
              color="#fff"
              title="Edit"
              arrow={false}
            >
              <span
                className={classNames('edit-text', { isEditing: isEditing && ((isPhone && isEditingPhone) || (!isPhone && isEditingEmail)) })}
                onClick={handleEditClick}
                onKeyPress={handleEditClick}
                role="button"
                aria-label="close"
                tabIndex={0}
                style={{ marginLeft: '4px' }}
              >
                <WhiteEditSvg />
              </span>
            </Tooltip>
          ) : null}
        </HeadingContent>
        {!visible && currentLanguage === 'en' ? (
          <TruncateMarkeup
            lines={rows}
            ellipsis={readMoreEllipsis}
          >
            {description || isEditing ? (
              isEditing && ((isPhone && isEditingPhone) || (!isPhone && isEditingEmail))
                ? (
                  <div className={classNames('editable', { isDisplay: editable })}>
                    <input
                      name="title"
                      value={editedText}
                      type={isPhone ? 'tel' : 'email'}
                      onChange={handleTextChange}
                      onKeyDown={onKeyDown}
                    />
                    <div className="icon-container">
                      <span
                        className="cross border-right"
                        onClick={handleEditCancel}
                        onKeyPress={handleEditCancel}
                        role="button"
                        aria-label="close"
                        tabIndex={0}
                      >
                        <Cross />
                        <span className="separator">|</span>
                      </span>
                      <span
                        className={classNames('tick', { disabled: disableHandleEdit() })}
                        onClick={handleEdit}
                        onKeyPress={handleEdit}
                        role="button"
                        aria-label="close"
                        tabIndex={0}
                      >
                        <Tick />
                      </span>
                    </div>
                  </div>
                )
                : (
                  <span className="para-text">
                    {description && HTMLReactParser(description)}
                  </span>
                )
            ) : (
              <span className="tiles-styling">
                Click on edit button to add
                {isPhone ? ' phone' : ' email'}
                .
              </span>
            )}
          </TruncateMarkeup>
        ) : (
          <span className="para-text">
            {description && HTMLReactParser(description)}
          </span>
        )}
        {/* <span className="tiles-styling">Click on Edit</span> */}
      </div>
    </Wrapper>
  );
};
TypographyBlock.defaultProps = defaultProps;
export default TypographyBlock;
